// 推荐管理
import { createAPI } from '@common'

export default {
  // 新建推荐
  // postColumnModules: (config) =>
  //   createAPI('customEncryptApiName-1/0w20dpmvno0npevmft', 'post', config),
  postColumnModules: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvno0npevmft', 'post', config),
  //还原推荐
  postColumnModulesRollBack: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvno0npevmft0spmmCbdl', 'post', config),
  // 修改推荐
  // putColumnModules: (config) => createAPI('customEncryptApiName-1/0w20dpmvno0npevmft', 'put', config),
  putColumnModules: (config) => createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvno0npevmft', 'put', config),
  // 获取推荐详情
  // getColumnModules: (config) => createAPI('customEncryptApiName-1/0w20dpmvno0npevmft', 'GET', config),
  getColumnModules: (config) => createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvno0npevmft', 'GET', config),
  // 新建、修改页面初始化参数
  // getColumnModulesInit: (config) =>
    // createAPI('customEncryptApiName-1/0w20dpmvno0npevmft0joju', 'GET', config),
  getColumnModulesInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvno0npevmft0joju', 'GET', config),
  // 排序
  // getColumnModulesSort: (config) =>
  //   createAPI('customEncryptApiName-1/0w20dpmvno0npevmft0tpsu', 'POST', config)
  getColumnModulesSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvno0npevmft0tpsu', 'POST', config)
}
